module.exports = __webpack_public_path__ + "static/media/2DGACM1.fe89e6cc.jpg";